import api from '@services';
import { getParamFromUrl } from '@assets/js/utils';

export const state = () => ({
  gameClassifyList: [],
  // 在直播间的时候，直播间的直播类型
  videoType: 0,
  // 房间中是否显示弹幕
  showDanmu: true,
  userInfo: {
    // 头像
    data5: '',
    bigo_id: '',
    nick_name: '',
    six: 0,
    birthday: '',
    hometown: '',
    introduction: ''
  }
});

export const mutations = {
  update_gameClassifyList(s, list) {
    s.gameClassifyList = list;
  },
  update_userInfo(s, userInfo) {
    s.userInfo = Object.assign(s.userInfo, userInfo);
  },
  update_videoType(s, videoType) {
    s.videoType = videoType;
  },
  update_showDanmu(s) {
    s.showDanmu = !s.showDanmu;
  }
};

export const actions = {
  async getGameClassifyList({ commit }) {
    const data = await api.getGameCategory();
    if (data && data.length > 0) {
      data.sort((a, b) => {
        const x = a.tabId === '6G';
        const y = b.tabId === '6G'; // 产品希望把  PUBG Mobile 提到最前面
        return y - x;
      });
      commit('update_gameClassifyList', data);
    }
  },
  async fetchUserInfo({ commit }) {
    const res = await api.getUserInfo();
    if (res && res.code === 0) {
      commit('update_userInfo', res.data);
    }
  }
};

export const getters = {
  // 首页游戏推荐的四个游戏标签
  gameRecommendLabel({ gameClassifyList }) {
    const gameList = gameClassifyList.slice(0, 7);
    const all = { tabId: '00', title: 'lang058' };
    gameList.unshift(all);
    return gameList;
  },
  isLogin({ userInfo }) {
    return !!userInfo.bigo_id;
  },
  myBigoId({ userInfo }) {
    return userInfo.bigo_id;
  },
  // 只要是分享页进来的，在页面中的跳转都认为是分享页，所以这个值不需要再继续更新
  isSharePage() {
    if (process.client) {
      return !!getParamFromUrl('b');
    }
    return false;
  },
  // 获取分享者的bigoId
  shareBigoId() {
    if (process.client) {
      return getParamFromUrl('b');
    }
    return '';
  }
};
